import Splide from '@splidejs/splide';

export default function initSlider() {
  document.querySelectorAll('.splide').forEach((slider) => {
    // noinspection JSCheckFunctionSignatures
    new Splide(slider, {
      type: 'loop',
      rewind: true,
      waitForTransition: false,
      lazyLoad: "nearby",
    })
      .on( 'autoplay:play autoplay:pause',() => slider.classList.toggle('slide-playing'))
      .mount();
  });
}
